/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpSharedBlurbReturns_item$ref: FragmentReference;
export type PdpSharedBlurbReturns_item = {|
  +blurbReturnPolicy: ?{|
    +accept: ?any,
    +notifyDays: ?string,
  |},
  +$refType: PdpSharedBlurbReturns_item$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpSharedBlurbReturns_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "blurbReturnPolicy",
      "name": "returnPolicy",
      "storageKey": null,
      "args": null,
      "concreteType": "ReturnPolicy",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "accept",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "notifyDays",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '539a4e804462921a9854e4b2df48a726';
module.exports = node;
